import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CashFlow from '../../../../views/CashFlow/CashFlow';

const NewIncomeRoute = () => {
	
	return (
		<div>
			<Routes>
				<Route path="" element={<CashFlow />} />				
			</Routes>
		</div>
	);
};

export default NewIncomeRoute;
